export const HUB_ROUTE_NAME = 'hub';
export const HUB_PREVIEW_ROUTE_NAME = 'hub-preview';
export const HUB_PREVIEW_ROUTE_PATH = '/s/:cloudId/hubs/:hubId/preview';
export const HUB_ROUTE_PATH = '/';
export const HUB_ROUTE_PATH_OPTIONAL_SLASH = '(/)?';

export const HUB_CUSTOM_PAGE_ROUTE_NAME = 'hub-custom-page';
export const HUB_CUSTOM_PAGE_ROUTE_PATH = '/page/:id/:title?';

export const HUB_PORTAL_PAGE_ROUTE_NAME = 'hub-portal-page';
export const HUB_PORTAL_PAGE_ROUTE_PATH = '/portal/:portalId';
